import { Routes } from '@angular/router';

import { AboutComponent } from './about/about.component';
import { HomeComponent } from './home/home.component';
import { FeaturesComponent } from './features/features.component';
import { PricingComponent } from './pricing/pricing.component';
import { DiscoverComponent } from './discover/discover.component';
import { TermsComponent } from '../pages/terms/terms.component';
import { PrivacyComponent } from '../pages/privacy/privacy.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { DEFAULT_SEO, PageSeo } from '../core/services/seo.service';

const NOT_FOUND_DATA = {
  title: 'Not found',
  seo: {
    title: 'Page not found | Talespinner',
    description: 'This page wandered off. Follow the thread back to Talespinner, the AI writing studio for novels and stories.',
    noindex: true,
  } satisfies PageSeo,
};

// `title` names the page in analytics; `seo` is what search results and link previews show.
// New public pages also need an entry in app.routes.server.ts (prerendering) and src/sitemap.xml.
export const landingRoutes: Routes = [
  {
    path: 'about', component: AboutComponent, data: {
      title: 'About',
      seo: {
        title: 'About Talespinner | Made by an indie developer in the Netherlands',
        description: 'Talespinner is made by Vincent Bons in the Netherlands. Why it exists, the AI models behind it, and how to get in touch.',
      } satisfies PageSeo,
    },
  },
  {
    path: 'features', component: FeaturesComponent, data: {
      title: 'Features',
      seo: {
        title: 'Features | Talespinner AI writing studio',
        description: 'Start from a genre, plot or characters, build your world, write chapters together with AI in your own voice, then generate a cover and share the finished book.',
      } satisfies PageSeo,
    },
  },
  {
    path: 'pricing', component: PricingComponent, data: {
      title: 'Pricing',
      seo: {
        title: 'Pricing | Pay per word, no subscription | Talespinner',
        description: 'No subscription: buy Quills at one cent each, spend them when the AI writes for you, and see the price of every generation before you press. Free Quills on sign-up.',
      } satisfies PageSeo,
    },
  },
  {
    path: 'discover', component: DiscoverComponent, data: {
      title: 'Discover',
      seo: {
        title: 'Discover books written with Talespinner',
        description: 'Read books finished by the Talespinner community: fantasy, romance, mystery and more, written by people with a little help from AI.',
      } satisfies PageSeo,
    },
  },
  {
    path: 'terms-of-service', component: TermsComponent, data: {
      title: 'Terms of service',
      seo: {
        title: 'Terms of service | Talespinner',
        description: 'The terms that apply when you use Talespinner, the AI writing studio operated by Bons AI.',
      } satisfies PageSeo,
    },
  },
  {
    path: 'privacy-policy', component: PrivacyComponent, data: {
      title: 'Privacy policy',
      seo: {
        title: 'Privacy policy | Talespinner',
        description: 'How Talespinner collects, uses and protects your personal data.',
      } satisfies PageSeo,
    },
  },
  { path: '', component: HomeComponent, pathMatch: 'full', data: { title: 'Home', seo: DEFAULT_SEO } },
  // '404' is prerendered and nginx serves it, with a 404 status, for any URL the app doesn't know.
  // The browser then routes that URL to '**', which renders the same page, so hydration matches.
  { path: '404', component: NotFoundComponent, data: NOT_FOUND_DATA },
  { path: '**', component: NotFoundComponent, data: NOT_FOUND_DATA },
];
